import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import HotelTabSidebar from "./Components/HotelTabSidebar";
import TuningSidebar from "./Components/TuningSidebar";
import useFetchMenu from "Common/FetchAllMenu";

const CommonSidebar = ({ iconColor }) => {
	const user = useSelector((state) => state.user);
	const location = useLocation();

	// =========================================================
	// CURRENT PAGE
	// =========================================================
	const currentPage =
		location.pathname.split("/")[1]?.split("/")[0] || "index";

	// =========================================================
	// TUNING MENU
	// =========================================================
	const { menu: tuningMenu = [] } = useFetchMenu("tunning");

	const tuningTabe = useMemo(() => {
		if (!Array.isArray(tuningMenu) || tuningMenu.length === 0) {
			return false;
		}

		return tuningMenu.some((parent) =>
			parent?.children?.some(
				(child) => child?.page_url === currentPage
			)
		);
	}, [tuningMenu, currentPage]);

	// =========================================================
	// HOTEL MENU
	// =========================================================
	const { menu: hotelMenu = [] } = useFetchMenu("hotel");

	const hotelTabe = useMemo(() => {
		if (!Array.isArray(hotelMenu) || hotelMenu.length === 0) {
			return false;
		}

		return hotelMenu.some((parent) =>
			parent?.children?.some(
				(child) =>
					child?.page_url === currentPage ||
					currentPage === "index"
			)
		);
	}, [hotelMenu, currentPage]);

	// =========================================================
	// CLOSE MOBILE OFFCANVAS AFTER CLICKING A LINK
	// =========================================================
	const handleSidebarClick = (e) => {
		const link = e.target.closest("a");

		if (!link) {
			return;
		}

		// Do not close the offcanvas for Bootstrap tab links
		if (link.hasAttribute("data-bs-toggle")) {
			return;
		}

		const offcanvasElement =
			document.getElementById("offcanvas_Navbar");

		if (!offcanvasElement) {
			return;
		}

		const closeBtn = offcanvasElement.querySelector(".btn-close");

		if (closeBtn) {
			closeBtn.click();
		}
	};

	return (
		<aside
			className="ps-3 pe-2 py-3 sidebar sticky-top d-flex flex-column justify-content-between"
			id="sidebarDark"
			data-bs-theme="none"
		>
			<nav className="navbar navbar-expand-xl py-0">
				<div
					className="offcanvas offcanvas-start"
					data-bs-scroll="true"
					tabIndex="-1"
					id="offcanvas_Navbar"
					aria-labelledby="offcanvasNavbarLabel"
				>
					{/* =====================================================
					    OFFCANVAS HEADER
					===================================================== */}
					<div className="offcanvas-header">
						<span
							id="offcanvasNavbarLabel"
							className="fw-bold fs-5 text-gradient"
						>
							PATIDAR SAMAJ
						</span>

						<button
							type="button"
							className="btn-close btn-close-white"
							data-bs-dismiss="offcanvas"
							aria-label="Close"
						/>
					</div>

					{/* =====================================================
					    OFFCANVAS BODY
					===================================================== */}
					<div
						className="offcanvas-body flex-column custom_scroll ps-4 ps-xl-0"
						onClick={handleSidebarClick}
					>
						{/* =================================================
						    LOGO / BRAND
						================================================= */}
						<div className="d-flex align-items-center mb-4">
							<Link
								to="/index"
								className="d-flex align-items-center text-decoration-none"
							>
								<img
									className="avatar"
									width={32}
									height={32}
									src={user?.logo}
									alt="Patidar Samaj"
								/>

								<div className="ms-2 mt-2">
									<h4 className="mb-0 text-gradient title-font">
										PATIDAR SAMAJ
									</h4>
								</div>
							</Link>
						</div>

						{/* =================================================
						    MAIN MENU TABS
						================================================= */}
						<ul
							className="nav nav-tabs tab-dynamic px-0 mb-4 me-auto w-100"
							role="tablist"
						>
							{/* HOTEL TAB */}
							<li className="nav-item" role="presentation">
								<Link
									className={`ps-2 pe-3 nav-link ${(hotelTabe || !tuningTabe) ? "active" : ""
										}`}
									data-bs-toggle="tab"
									to="#tab_hotels"
									role="tab"
									aria-controls="tab_hotels"
									aria-selected={hotelTabe}
								>
									HOTELS
								</Link>
							</li>

							{/* TUNING TAB */}
							<li className="nav-item" role="presentation">
								<Link
									className={`ps-2 pe-3 nav-link ${tuningTabe ? "active" : ""
										}`}
									data-bs-toggle="tab"
									to="#tab_settings"
									role="tab"
									aria-controls="tab_settings"
									aria-selected={tuningTabe}
								>
									TUNING
								</Link>
							</li>
						</ul>

						{/* =================================================
						    TAB CONTENT
						================================================= */}
						<div className="tab-content">
							{/* =================================================
							    HOTEL TAB
							================================================= */}
							<div
								className={`tab-pane fade ${hotelTabe ? "show active" : ""
									}`}
								id="tab_hotels"
								role="tabpanel"
								aria-labelledby="tab-hotels"
							>
								<HotelTabSidebar iconColor={iconColor} />
							</div>

							{/* =================================================
							    TUNING TAB
							================================================= */}
							<div
								className={`tab-pane fade ${tuningTabe ? "show active" : ""
									}`}
								id="tab_settings"
								role="tabpanel"
								aria-labelledby="tab-settings"
							>
								<TuningSidebar iconColor={iconColor} />
							</div>
						</div>
					</div>
				</div>
			</nav>

			{/* =========================================================
			    FOOTER / PIXELWIBES
			========================================================= */}
			<a
				href="https://pixelwibes.com/"
				target="_blank"
				rel="noopener noreferrer"
				className="sticky-bottom text-decoration-none d-inline-block mb-0 p-3 bg-body shadow-none rounded-2"
			>
				<h5
					className="fw-bold mb-0"
					style={{ letterSpacing: "1.5px" }}
				>
					Pixel<span className="text-primary">Wibes</span>
				</h5>

				<small className="text-muted d-block text-nowrap text-truncate">
					Connecting Pixel Wibes to Development
				</small>
			</a>
		</aside>
	);
};

export default CommonSidebar;